import env from "./env"
import settings from "./settings"

const configConstructor = (() => {
    
    let envInstance = {};
    let userDetailsInstance = {};
    let settingsInstance = {};
    let permissionToken = null;

    const getEnv = () => {
        return {...envInstance}
    }

    const setEnv = () => {
        envInstance = {...envInstance, ...env}
    }

    const setUserDetails = (userDetails) => {
        userDetailsInstance =  {...userDetailsInstance, ...userDetails};
    }

    const getUserDetails = () => {
        return {...userDetailsInstance}
    }

    const setSettings = () => {
        settingsInstance =  {...settingsInstance, ...settings};
    }

    const getSettings = () => {
        return {...settingsInstance}
    }

    const setPermissionToken = (_permissionToken) => {
        setSettings();
        window.__LOS__getPermissionToken = () => _permissionToken;
        permissionToken = _permissionToken;
    }
    
    const getPermissionToken = () => {
        return permissionToken;
    }

    setEnv();
    setSettings();

    return {
        getEnv,
        setUserDetails,
        getUserDetails,
        getSettings,
        setPermissionToken,
        getPermissionToken
    }
})();


export default configConstructor;